import { Link } from 'react-router-dom';
import { Linkedin, Instagram, Facebook } from 'lucide-react';
import Logo from './Logo';

const socialIconClass = 'transition-colors duration-200';

export default function Footer() {
  return (
    <footer style={{ background: '#111' }} className="pb-8 pt-14 text-white md:pt-16">
      <div className="page-container-wide">
        <div className="mb-10 grid grid-cols-1 gap-8 md:mb-12 md:grid-cols-5 md:gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <Logo scrolled={true} forceWhite={true} whiteText={true} />

            <p className="mb-3 mt-4 text-sm italic text-white/60">
              Fast. Flexible. Reliable.
            </p>

            <p className="mb-5 max-w-md text-sm leading-relaxed text-white/60">
              Business funding built on speed, consistency, and long-term partnerships.
            </p>

            {/* BBB Badge Placeholder */}
            <a
              href="#"
              className="inline-flex items-center justify-center rounded-xl border border-white/15 px-4 py-3 text-sm font-medium text-white/80 hover:text-white hover:border-white/30 transition-colors"
            >
              BBB Accredited Business
            </a>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-white/40 mb-4 font-semibold">
              Company
            </h4>
            <ul className="space-y-2.5 text-sm text-white/60">
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  About Bizfund
                </Link>
              </li>
              <li>
                <Link to="/what-we-offer" className="hover:text-white transition-colors">
                  What We Offer
                </Link>
              </li>
              <li>
                <Link to="/industries" className="hover:text-white transition-colors">
                  Industries
                </Link>
              </li>
              <li>
                <Link to="/merchandise" className="hover:text-white transition-colors">
                  Merchandise
                </Link>
              </li>
            </ul>
          </div>

          {/* Actions */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-white/40 mb-4 font-semibold">
              Actions
            </h4>
            <ul className="space-y-2.5 text-sm text-white/60">
              <li>
                <Link to="/apply" className="hover:text-white transition-colors">
                  Apply for Funding
                </Link>
              </li>
              <li>
                <Link to="/partner" className="hover:text-white transition-colors">
                  Partner with Us
                </Link>
              </li>
              <li>
                <Link to="/login" className="hover:text-white transition-colors">
                  Login
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-white/40 mb-4 font-semibold">
              Contact
            </h4>
            <ul className="mb-5 space-y-2.5 text-sm text-white/60">
              <li>
                <a
                  href="mailto:accounting@bizfund.com"
                  className="hover:text-white transition-colors"
                >
                  accounting@bizfund.com
                </a>
              </li>
              <li>
                <a
                  href="mailto:funding@bizfund.com"
                  className="hover:text-white transition-colors"
                >
                  funding@bizfund.com
                </a>
              </li>
              <li>
                <a
                  href="mailto:partner@bizfund.com"
                  className="hover:text-white transition-colors"
                >
                  partner@bizfund.com
                </a>
              </li>
            </ul>

            <div>
              <h5 className="text-xs uppercase tracking-widest text-white/40 mb-3 font-semibold">
                Follow
              </h5>
              <div className="flex items-center gap-3">
                <a
                  href="#"
                  aria-label="LinkedIn"
                  className={`p-2 rounded-full border border-white/15 ${socialIconClass} text-white/70 hover:text-white hover:border-white/30 linkedin`}
                >
                  <Linkedin size={16} className="linkedin" />
                </a>
                <a
                  href="#"
                  aria-label="Instagram"
                  className={`p-2 rounded-full border border-white/15 ${socialIconClass} text-white/70 hover:text-white hover:border-white/30 instagram`}
                >
                  <Instagram size={16} className="instagram" />
                </a>
                <a
                  href="#"
                  aria-label="Facebook"
                  className={`p-2 rounded-full border border-white/15 ${socialIconClass} text-white/70 hover:text-white hover:border-white/30 facebook`}
                >
                  <Facebook size={16} className="facebook" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="my-8 flex justify-center md:my-10">
            <p className="inline-flex items-center rounded-full border border-blue-300/40 bg-gradient-to-r from-blue-600 via-sky-500 to-cyan-400 px-5 py-2 text-center text-sm font-semibold uppercase tracking-[0.18em] text-white shadow-[0_12px_32px_rgba(37,99,235,0.28)]">
              Trusted by businesses and brokers nationwide.
            </p>
        </div>

        <div className="mb-6">
          <p className="text-xs text-white/40 leading-relaxed">
            Bizfund LLC provides merchant cash advances, which are purchases of future business
            receivables and are not loans. Bizfund LLC is licensed in CA, CT, NV, MO, UT, and
            VA. Products are available in all states except Texas. Texas-based businesses are
            served through a separate funding partner. All funding is subject to underwriting
            review and approval. Terms and conditions apply. Bizfund LLC is not a lender.
          </p>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 pt-5 md:flex-row md:pt-6">
          <p className="text-xs text-white/30">
            © 2025 Bizfund LLC. All rights reserved.
          </p>

          <div className="flex flex-wrap gap-6 text-xs text-white/30">
            <Link to="/privacy" className="hover:text-white/60 transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white/60 transition-colors">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
